export default {"src":"/nachrichten/_next/static/media/not-found-dark.cd5b88eb.svg","height":130,"width":187,"blurWidth":0,"blurHeight":0};